import { authRoles } from './auth/authRoles';

export const navigations = [
    {
        auth: {
            name: ['dashboard'],
            permissions: ['view', 'create', 'edit'],  // Permissões necessárias
        },
        name: 'Dashboard',
        path: '/dashboard',
        urlIcon: '/assets/images/usemais/dashboard.svg',
    },
    {
        auth: {
            name: ['users', 'profile'],
            permissions: ['view', 'create', 'edit'],  // Permissões necessárias
        },
        name: 'Cadastro',
        urlIcon: '/assets/images/usemais/cadastro.svg',
        children:
        [
            {
                auth: {
                    name: ['profile'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'Perfil',
                path: '/profile',
                urlIcon: '/assets/images/usemais/perfil.svg',

            },
            {
                auth: {
                    name: ['users'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'Usuários',
                path: '/usuario',
                urlIcon: '/assets/images/usemais/usuarios.svg',
            }
        ]
    },
    {
        auth: {
            name: ['clients'],
            permissions: ['view', 'create', 'edit'],  // Permissões necessárias
        },
        name: 'Clientes',
        urlIcon: '/assets/images/usemais/clientes.svg',
        path: '/clientes'
    },
    {
        auth: {
            name: ['partners'],
            permissions: ['view', 'create', 'edit'],  // Permissões necessárias
        },
        name: 'Parceiros',
        path: '/parceiros',
        urlIcon: '/assets/images/usemais/parceiros.svg',
    },
    {
        auth: {
            name: ['ads'],
            permissions: ['view', 'create', 'edit'],  // Permissões necessárias
        },
        name: 'Anúncios/Vídeos',
        urlIcon: '/assets/images/usemais/anuncios.svg',
        path: '/anuncios',
    },
    {
        auth: {
            name: ['gifts'],
            permissions: ['view', 'create', 'edit'],  // Permissões necessárias
        },
        name: 'Gifts',
        urlIcon: '/assets/images/usemais/gifts.svg',
        children: [
            {
                auth: {
                    name: ['gifts'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'Gifts exclusivos',
                path: '/cupons/exclusivos/listar',
                urlIcon: '/assets/images/usemais/star.svg',
            },
            {
                auth: {
                    name: ['gifts'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'Código de pontos',
                path: '/cupons/pontos/listar',
                urlIcon: '/assets/images/usemais/coin.svg',
            },
        ],
    },
    {
        auth: {
            name: ['gifts'],
            permissions: ['view', 'create', 'edit'],  // Permissões necessárias
        },
        name: 'Planos',
        urlIcon: '/assets/images/usemais/planos.svg',
        path: '/planos',
    },
    {
        auth: {
            name: ['financeiro'],
            permissions: ['view', 'create', 'edit'],
        },
        name: 'Financeiro',
        urlIcon: '/assets/images/usemais/financeiro.svg',
        path: '/financeiro/administrativo',
    },
    {
        auth: {
            name: ['banners'],
            permissions: ['view', 'create', 'edit'],
        },
        name: 'Banners',
        urlIcon: '/assets/images/usemais/anuncios.svg',
        path: '/banners',
    },
    {
        auth: {
            name: ['campaigns'],
            permissions: ['view', 'create', 'edit'],
        },
        name: 'Campanhas',
        urlIcon: '/assets/images/usemais/star.svg',
        path: '/campanhas',
    },
    {
        auth: {
            name: ['settings'],
            permissions: ['view', 'create', 'edit'],
        },
        name: 'Configurações',
        urlIcon: '/assets/images/usemais/cadastro.svg',
        children: [
            {
                auth: {
                    name: ['settings'],
                    permissions: ['view', 'create', 'edit'],
                },
                name: 'Provedores',
                path: '/configuracoes/provedores',
                urlIcon: '/assets/images/usemais/perfil.svg',
            },
            {
                auth: {
                    name: ['settings'],
                    permissions: ['view', 'create', 'edit'],
                },
                name: 'Recompensas',
                path: '/configuracoes/recompensas',
                urlIcon: '/assets/images/usemais/star.svg',
            },
            {
                auth: {
                    name: ['settings'],
                    permissions: ['view', 'create', 'edit'],
                },
                name: 'Listas',
                path: '/configuracoes/listas',
                urlIcon: '/assets/images/usemais/coin.svg',
            },
        ],
    },
    {
        auth: {
            name: ['reports'],
            permissions: ['view', 'create', 'edit'],  // Permissões necessárias
        },
        name: 'Relatórios',
        urlIcon: '/assets/images/usemais/relatorios.svg',
        children:
        [
            {
                auth: {
                    name: ['reports'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'Gifts Geral',
                path: '/relatorio/geral',
                urlIcon: '/assets/images/usemais/rGfit.svg',

            },
            {
                auth: {
                    name: ['reports'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'Gifts Resgatados',
                path: '/relatorio/resgates',
                urlIcon: '/assets/images/usemais/rResgates.svg',

            },
            {
                auth: {
                    name: ['reports'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'Pontos',
                path: '/relatorio/pontos',
                urlIcon: '/assets/images/usemais/rPontos.svg',

            },
            {
                auth: {
                    name: ['reports'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'Resultado Anúncios',
                path: '/relatorio/anuncios',
                urlIcon: '/assets/images/usemais/rAnuncios.svg',
            },
            {
                auth: {
                    name: ['reports'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'Planos Contratados',
                path: '/relatorio/planos',
                urlIcon: '/assets/images/usemais/rAnuncios.svg',
            }
        ]
    },
    {
        auth: {
            name: ['system_log'],
            permissions: ['view', 'create', 'edit'],  // Permissões necessárias
        },
        name: 'Logs',
        urlIcon: '/assets/images/usemais/relatorios.svg',
        children:
        [
            {
                auth: {
                    name: ['reports'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'LOG Auditoria',
                path: '/logs/auditoria',
                urlIcon: '/assets/images/usemais/log.svg',

            },
            {
                auth: {
                    name: ['reports'],
                    permissions: ['view', 'create', 'edit'],  // Permissões necessárias
                },
                name: 'LOG Acesso',
                path: '/logs/acesso',
                urlIcon: '/assets/images/usemais/log.svg',

            },
        ]
    }
];

export const oldNavigations = [

    //ANUNCIANTE
    // {
    //     auth: authRoles.anunciante,
    //     label: 'Anunciante',
    //     type: 'label',
    // },
    // {
    //     auth: authRoles.anunciante,
    //     name: 'Dashboard',
    //     path: '/administracao/dashboard',
    //     urlIcon: '/assets/images/usemais/dashboard.svg',
    // },
    {
        auth: authRoles.anunciante,
        name: 'Dashboard',
        path: '/dashboard',
        urlIcon: '/assets/images/usemais/dashboard.svg',
    },
    {
        auth: authRoles.anunciante,
        name: 'Cadastro',
        urlIcon: '/assets/images/usemais/cadastro.svg',
        children:
        [
            {
                auth: authRoles.anunciante,
                name: 'Perfil',
                path: '/profile',
                urlIcon: '/assets/images/usemais/perfil.svg',

            },
            {
                auth: authRoles.anunciante,
                name: 'Usuários',
                path: '/usuario',
                urlIcon: '/assets/images/usemais/usuarios.svg',
            }
        ]
    },
    {
        auth: authRoles.viewCli,
        name: 'Clientes',
        urlIcon: '/assets/images/usemais/clientes.svg',
        path: '/clientes',
        // children: [
        //     {
        //         name: 'Dados Cadastrais',
        //         path: '/clientes',
        //         icon: 'person',
        //         auth: authRoles.viewCli,
        //     },

        //     {
        //         name: 'Extrato de pontos',
        //         path: '/clientes/extratos/geral',
        //         icon: 'note',
        //         auth: authRoles.viewCli,
        //     },

        // ],
    },
    {
        auth: authRoles.viewAnun,
        name: 'Parceiros',
        path: '/parceiros',
        urlIcon: '/assets/images/usemais/parceiros.svg',
        // children: [
        //     {
        //         name: 'Cadastro',

        //         icon: 'business',
        //         auth: authRoles.viewAnun,
        //     },
        // ]
    },
    {
        auth: authRoles.viewPubli,
        name: 'Anúncios',
        urlIcon: '/assets/images/usemais/anuncios.svg',
        path: '/anuncios',
        // children: [
        //     {
        //         name: 'Super Banners',
        //         path: '/banners',
        //         icon: 'group',
        //         auth: authRoles.viewPubli,
        //     },
        // ]
    },
    // {
    //     name: 'Central de anúncios',
    //     path: '/dashboard',
    //     urlIcon: '/assets/images/assistamais/sidebar/grid_on_24px.svg',
    //     children: [
    //         {
    //             name: 'Criar campanhas',
    //             iconText: 'SI',
    //             path: '/session/signin',
    //         },
    //         {
    //             name: 'Ver campanhas',
    //             iconText: 'SU',
    //             path: '/session/signup',
    //         }
    //     ],
    // },
    {
        auth: authRoles.anunciante,
        name: 'Gifts',
        urlIcon: '/assets/images/usemais/gifts.svg',
        children: [
            {
                name: 'Gifts exclusivos',
                path: '/cupons/exclusivos/listar',
                urlIcon: '/assets/images/usemais/star.svg',
                // auth: authRoles.anunciante,
            },
            {
                name: 'Código de pontos',
                path: '/cupons/pontos/listar',
                urlIcon: '/assets/images/usemais/coin.svg',
                // auth: authRoles.anunciante,
            },
        ],
    },
    // {
    //     auth: authRoles.anunciante,
    //     name: 'Financeiro',
    //     urlIcon: '/assets/images/usemais/financeiro.svg',
    //     path: '/financeiro/administrativo',
    // },
    {
        auth: authRoles.anunciante,
        name: 'Relatórios',
        urlIcon: '/assets/images/usemais/relatorios.svg',
        children:
        [
            {
                auth: authRoles.anunciante,
                name: 'Gifts Geral',
                path: '/relatorio/geral',
                urlIcon: '/assets/images/usemais/rGfit.svg',

            },
            {
                auth: authRoles.anunciante,
                name: 'Gifts Resgatados',
                path: '/relatorio/resgates',
                urlIcon: '/assets/images/usemais/rResgates.svg',

            },
            {
                auth: authRoles.anunciante,
                name: 'Pontos',
                path: '/relatorio/pontos',
                urlIcon: '/assets/images/usemais/rPontos.svg',

            },
            {
                auth: authRoles.anunciante,
                name: 'Resultado Anúncios',
                path: '/relatorio/anuncios',
                urlIcon: '/assets/images/usemais/rAnuncios.svg',

            }
        ]
    // children: [
    //     {
    //         name: 'Super Banners',
    //         path: '/banners',
    //         icon: 'group',
    //         auth: authRoles.viewPubli,
    //     },
    // ]
    },
    // {
    //     auth: authRoles.anunciante,
    //     name: 'Central de anúncios',
    //     path: '/dashboard',
    //     urlIcon: '/assets/images/assistamais/sidebar/grid_on_24px.svg',

    // },
    // {
    //     auth: authRoles.anunciante,
    //     name: 'Carteira',
    //     path: '/dashboard',
    //     urlIcon: '/assets/images/assistamais/sidebar/account_balance_wallet_24px.svg',
    // },

    // {
    //     auth: authRoles.anunciante,
    //     name: 'Usuários',
    //     urlIcon: '/assets/images/assistamais/sidebar/users.png',
    //     children: [
    //         {
    //             auth: authRoles.anunciante,
    //             name: 'Cadastro dos Usuários',
    //             path: '/anunciantes/usuarios',
    //             icon: 'group_add',
    //         }

    //     ],
    // },
    {
        auth: authRoles.viewLog,
        name: 'LOG',
        path: '/logs',
        urlIcon: '/assets/images/usemais/log.svg',
    },

    //ADMINISTRADOR

    // {
    //     auth: authRoles.viewDash,
    //     label: 'Administração',
    //     type: 'label',
    // },
    // {
    //     auth: authRoles.viewDash,
    //     name: 'Dashboard',
    //     path: '/administracao/dashboard',
    //     urlIcon: '/assets/images/assistamais/sidebar/dashboard.png',
    // },
    // {
    //     auth: authRoles.viewFin,
    //     name: 'Financeiro',
    //     urlIcon: '/assets/images/assistamais/sidebar/icons8-fluxo-de-caixa-24.png',
    //     children: [
    //         {
    //             name: 'Anunciante',
    //             path: '/financeiro/administrativo',
    //             icon: 'people'
    //         },
    //         {
    //             name: 'Faturas',
    //             path: '/financeiro/administrativo/faturas',
    //             icon: 'attach_money'
    //         },

    //     ]
    // },
    // {
    //     auth: authRoles.viewCamp,
    //     name: 'Campanhas',
    //     urlIcon: '/assets/images/assistamais/sidebar/cupom.svg',
    //     children: [
    //         {
    //             name: 'Cadastrar',
    //             path: '/campanhas/visualizar',
    //             icon: 'card_giftcard',
    //             auth: authRoles.viewCamp,
    //         },
    //     ],
    // },
    // {
    //     auth: authRoles.viewPerm,
    //     name: 'Permissões',
    //     urlIcon: '/assets/images/assistamais/sidebar/anunciantes.png',
    //     children: [
    //         {
    //             name: 'Cadastro',
    //             path: '/permissao',
    //             icon: 'business',
    //             auth: authRoles.viewPerm,
    //         }
    //     ]
    // },
    // {
    //     auth: authRoles.viewPubli,
    //     name: 'Publicidades',
    //     urlIcon: '/assets/images/assistamais/sidebar/anunciantes.png',
    //     children: [
    //         {
    //             name: 'Super Banners',
    //             path: '/banners',
    //             icon: 'group',
    //             auth: authRoles.viewPubli,
    //         },
    //     ]
    // },
    // {
    //     auth: authRoles.viewCup,
    //     name: 'Cupons',
    //     urlIcon: '/assets/images/assistamais/sidebar/cupom.svg',
    //     children: [
    //         {
    //             name: 'Gerar Cupons',
    //             path: '/cupons/listar',
    //             icon: 'confirmation_number',
    //             auth: authRoles.viewCup,
    //         },
    //         {
    //             name: 'Vale Presente',
    //             path: '/cupons/resgates',
    //             icon: 'card_giftcard',
    //             auth: authRoles.viewVP,
    //         },
    //         {
    //             name: 'Validação Resgates',
    //             path: '/clientes/validacao-resgates',
    //             icon: 'confirmation_number',
    //             auth: authRoles.viewVP,
    //         },
    //     ],
    // },

    // {
    //     auth: authRoles.viewPerm,
    //     name: 'Permissoes',
    //     urlIcon: '/assets/images/assistamais/sidebar/anunciantes.png',
    //     children: [
    //         {
    //             name: 'Cadastro',
    //             path: '/permissao',
    //             icon: 'business',
    //             auth: authRoles.viewPerm,
    //         }
    //     ]
    // },
    // {
    //     auth: authRoles.viewLog,
    //     name: 'LOG',
    //     path: '/logs',
    //     urlIcon: '/assets/images/assistamais/sidebar/mono-save.svg',
    // },
    // {
    //     auth: authRoles.viewFaq,
    //     name: 'FAQ',
    //     path: '/faq',
    //     urlIcon: '/assets/images/assistamais/sidebar/anunciantes.png',
    // },
    // {
    //     auth: authRoles.viewUsu,
    //     name: 'Usuários',
    //     urlIcon: '/assets/images/assistamais/sidebar/users.png',
    //     children: [
    //         {
    //             auth: authRoles.viewUsu,
    //             name: 'Cadastro dos Usuários',
    //             path: '/administracao/usuarios',
    //             icon: 'group_add',
    //         }

    //     ],
    // },
    // {
    //     auth: authRoles.viewConf,
    //     name: 'Configurações',
    //     urlIcon: '/assets/images/assistamais/sidebar/settings.png',
    //     children: [
    //         {
    //             auth: authRoles.viewList,
    //             name: 'Provedores',
    //             path: '/configuracoes/provedores',
    //             icon: 'ondemand_video'
    //         },
    //         {
    //             auth: authRoles.viewList,
    //             name: 'Recompensas (Gift Card)',
    //             path: '/configuracoes/recompensas',
    //             icon: 'shopping_cart'
    //         },
    //         {
    //             auth: authRoles.viewList,
    //             name: 'Listas',
    //             path: '/configuracoes/listas',
    //             icon: 'list'
    //         }

    //     ],
    // },
    // {
    //     label: `Versão`,
    //     type: 'label',
    // },
    // {
    //     name: 'Trocar senha',
    //     path: '/administracao/trocar-senha',
    //     urlIcon: '/assets/images/assistamais/sidebar/cached_24px.svg',
    // },
    // {
    //     name: 'Sair',
    //     path: '/session/signout',
    //     urlIcon: '/assets/images/assistamais/sidebar/exit_to_app_24px.svg',
    // },
]

/**
    {
        name: 'Session/Auth',
        icon: 'security',
        children: [
            {
                name: 'Sign in',
                iconText: 'SI',
                path: '/session/signin',
            },
            {
                name: 'Sign up',
                iconText: 'SU',
                path: '/session/signup',
            },
            {
                name: 'Forgot Password',
                iconText: 'FP',
                path: '/session/forgot-password',
            },
            {
                name: 'Error',
                iconText: '404',
                path: '/session/404',
            },
        ],
    },

    {
        label: 'Components',
        type: 'label',
    },
    {
        name: 'Components',
        icon: 'favorite',
        badge: { value: '30+', color: 'secondary' },
        children: [
            {
                name: 'Auto Complete',
                path: '/material/autocomplete',
                iconText: 'A',
            },
            {
                name: 'Buttons',
                path: '/material/buttons',
                iconText: 'B',
            },
            {
                name: 'Checkbox',
                path: '/material/checkbox',
                iconText: 'C',
            },
            {
                name: 'Dialog',
                path: '/material/dialog',
                iconText: 'D',
            },
            {
                name: 'Drag and Drop',
                iconText: 'D',
                path: '/others/drag-and-drop',
            },
            {
                name: 'Expansion Panel',
                path: '/material/expansion-panel',
                iconText: 'E',
            },
            {
                name: 'Form',
                path: '/material/form',
                iconText: 'F',
            },
            {
                name: 'Icons',
                path: '/material/icons',
                iconText: 'I',
            },
            {
                name: 'Menu',
                path: '/material/menu',
                iconText: 'M',
            },
            {
                name: 'Progress',
                path: '/material/progress',
                iconText: 'P',
            },
            {
                name: 'Radio',
                path: '/material/radio',
                iconText: 'R',
            },
            {
                name: 'Switch',
                path: '/material/switch',
                iconText: 'S',
            },
            {
                name: 'Slider',
                path: '/material/slider',
                iconText: 'S',
            },
            {
                name: 'Snackbar',
                path: '/material/snackbar',
                iconText: 'S',
            },
            {
                name: 'Table',
                path: '/material/table',
                iconText: 'T',
            },
        ],
    },
    {
        name: 'Utilities',
        icon: 'format_list_bulleted',
        children: [
            {
                name: 'Color',
                path: '/utilities/color',
                iconText: 'C',
                auth: authRoles.admin,
            },
            {
                name: 'Spacing',
                path: '/utilities/spacing',
                iconText: 'S',
                auth: authRoles.admin,
            },
            {
                name: 'Typography',
                path: '/utilities/typography',
                iconText: 'T',
            },
            {
                name: 'Display',
                path: '/utilities/display',
                iconText: 'D',
            },
            {
                name: 'Position',
                path: '/utilities/position',
                iconText: 'P',
            },
            {
                name: 'Shadow',
                path: '/utilities/shadow',
                iconText: 'S',
            },
        ],
    },
    {
        name: 'Charts',
        icon: 'trending_up',
        children: [
            {
                name: 'Echarts',
                path: '/charts/echarts',
                iconText: 'E',
            }
        ],
    },
    {
        name: 'Documentation',
        icon: 'launch',
        type: 'extLink',
        path: 'http://demos.ui-lib.com/matx-react-doc/',
    },
] **/
